import { useState, useCallback, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { SearchFormValues } from '../../../common/types/form'

type UseSearchStateProps = {
  defaultSearchInput: string
  resetOnClose?: boolean
}

export const useSearchState = ({
  defaultSearchInput,
  resetOnClose = false,
}: UseSearchStateProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [showContextChip, setShowContextChip] = useState(false)
  const [userDismissedChip, setUserDismissedChip] = useState(false)

  const form = useForm<SearchFormValues>({
    defaultValues: {
      searchInput: defaultSearchInput,
    },
  })

  const { watch, setValue, reset } = form
  const searchInput = watch('searchInput')

  const resetToDefaults = useCallback(() => {
    reset({ searchInput: defaultSearchInput })
    setUserDismissedChip(false)
  }, [reset, defaultSearchInput])

  useEffect(() => {
    if (isOpen && resetOnClose) {
      resetToDefaults()
    }
  }, [isOpen, resetOnClose, resetToDefaults])

  const handleClearInput = useCallback(() => {
    reset({ searchInput: '' })
  }, [reset])

  return {
    isOpen,
    setIsOpen,
    searchInput,
    setValue,
    showContextChip,
    setShowContextChip,
    userDismissedChip,
    setUserDismissedChip,
    handleClearInput,
    form,
    resetToDefaults,
  }
}
